// extracted by mini-css-extract-plugin
export default {"cls1":"WfMbeEcU0jTyJo1sRBFF","cls2":"J0FaxHgSCghQ1niZARbC WfMbeEcU0jTyJo1sRBFF"};